import React from 'react';
import Lottie from 'lottie-react';
import nvgtrLoader from '../../loaders/nvgtr_loader_white.json';
import nvgtrLoaderWhite from '../../loaders/nvgtr_loader_white.json';
import { useTheme } from '../../features/theme/context/ThemeContext';

const OfflineScreen = () => {
  const { darkMode } = useTheme();
  
  return (
    <div className={`fixed inset-0 ${darkMode ? 'bg-[#020202] text-white' : 'bg-white'} flex flex-col items-center justify-center px-6 pb-[env(safe-area-inset-bottom)] pt-[calc(env(safe-area-inset-top)+2rem)]`}>
      <div className="w-24 h-24 mb-8">
        <Lottie animationData={darkMode ? nvgtrLoaderWhite : nvgtrLoader} loop={true} />
      </div>
      
      <div className="text-center max-w-[280px]">
        <div className="flex justify-center mb-6">
          <img src="/no-wifi.svg" className="w-12 h-12" alt="No WiFi Icon" />
        </div>

        <h1 className="text-2xl font-semibold mb-3 font-['Poppins']">
          No Internet Connection
        </h1>
        
        <p className={`text-sm mb-8 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
          Check your connection and try again
        </p>

        <button 
          onClick={() => window.location.reload()}
          className="w-full py-3 bg-black text-white rounded-lg font-medium transition-colors hover:bg-gray-900 active:bg-gray-800"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default OfflineScreen; 